import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { OfferCardDiscountTag } from './OfferCardDiscountTag';
import { mapCurrencyToSymbol } from './utils';
export function OfferCardDiscountPrice({ regularPrice, discountType, locale, currency, withDiscountTag, }) {
    const formattedPrice = regularPrice.toLocaleString(locale, {
        minimumFractionDigits: 2,
    });
    return (_jsxs(Box, { testId: "offer-card-discount-type", display: "flex", width: "100%", justifyContent: "space-between", children: [_jsx(Box, { typography: "typography.body.14.regular", color: "color.content.subdued.default", testId: "offer-card-regular-price", children: _jsxs("s", { children: [_jsx(Box, { as: "span", children: formattedPrice }), ' ', _jsx(Box, { as: "span", children: mapCurrencyToSymbol(currency) })] }) }), withDiscountTag && _jsx(OfferCardDiscountTag, { discountType: discountType })] }));
}
